import { render, staticRenderFns } from "./broadcast-result.vue?vue&type=template&id=b84833ca&scoped=true&"
import script from "./broadcast-result.vue?vue&type=script&lang=js&"
export * from "./broadcast-result.vue?vue&type=script&lang=js&"
import style0 from "./broadcast-result.vue?vue&type=style&index=0&id=b84833ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84833ca",
  null
  
)

export default component.exports